import { useEffect } from 'react';

const MatomoTagManager = () => {
  useEffect(() => {
    const initMatomo = () => {
      window._mtm = window._mtm ?? [];
      window._mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });

      const script = document.createElement('script');
      script.async = true;
      script.src = import.meta.env.VITE_MATOMO_TAG_MANAGER_URL;

      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(script, firstScript);
    };

    if (!window._mtm && import.meta.env.MODE !== 'development') {
      initMatomo();
    }

    return () => {
      const existingScript = document.querySelector(
        `script[src="${import.meta.env.VITE_MATOMO_TAG_MANAGER_URL}"]`
      );
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default MatomoTagManager;
